import React, { useState, useEffect } from "react";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import MiscPOModal from "../components/miscPoSuplplierModal";
import Time from "../components/time";
import { useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";

const AddBOPurchaseOrder = () => {
  useAuthRedirect();
  const [showModal, setShowModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]); 
  const branch = localStorage.getItem("branch");
  const user = localStorage.getItem("username");
  const [priNumber, setPriNumber] = useState(null);  
  const [supplierNo, setSupplierNo] = useState(null);  
const [poNumber, setPoNo] = useState(""); 
const [subDetails, setSubDetails] = useState({})
const [formData, setFormData] = useState({})
const navigate = useNavigate();
const canEntry = hasPermission("Branch Office Purchase Order", "entry");

useEffect(() => {
  const fetchPoNo = async () => {
    try {
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/bopurchase_no?branch=${branch}`);
      if (response.data.PoNo) {
        const NewPo = parseInt(response.data.PoNo, 10) || 0;
        setPoNo(NewPo.toString());
        setFormData(prevState => ({ ...prevState, PoNumber: NewPo.toString() }));
      }
    } catch (error) {
      console.error("Error fetching indent number:", error);
    }
  };
  fetchPoNo();
}, [branch]);

const handleSelectItem = async (supplier) => {
  try {
    setSupplierNo(supplier.supplierMaster_code)

    const response = await axios.get("https://rfs2.infraconsoft.net.in/api/bogetSupplierItems", {
      params: {
        sCode: supplier.supplierMaster_code,
        branch: branch,
      },
    });

    if (response.data.length > 0) {
      setSelectedItems(response.data);
    }
  } catch (error) {
    console.error("Error fetching supplier items:", error);
  }
};


useEffect(() => {
    const fetchSupplierDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/purchaseOrder_supDetails?supplierCode=${supplierNo}`);
            const items = response.data.supDetails;
            console.log(response.data.supDetails);
            
            const storeReqHeader1 = {
                supplierMaster_code: items[0].supplierMaster_code || "N/A",
                supplierMaster_name: items[0].supplierMaster_name || "N/A",
                supplierMaster_addressline1 : items[0].supplierMaster_addressline1 || "N/A",
                supplierMaster_addressline2 : items[0].supplierMaster_addressline2 || "N/A",
                supplierMaster_city : items[0].supplierMaster_city || "N/A",
                supplierMaster_pincode : items[0].supplierMaster_pincode || "N/A",
                
            };
            setSubDetails(storeReqHeader1);
            // setData(response.data.supDetails);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchSupplierDetails();
  }, [supplierNo]); 


  // Calculate totals
  const totals = selectedItems.reduce(
    (acc, item) => {
        const itemValue = item.prDetail_quantity * item.prDetail_price;
        const discountValue = itemValue * (item.supplierWIdetail_discountPercentage / 100);
        const pfValue = itemValue * (item.supplierWIdetail_PfPercentage / 100);
        const taxValue = itemValue * (item.SupplierWIDetail_CSTtax / 100);
        const totalValue = itemValue + taxValue + pfValue - discountValue;

      acc.totalItemValue += itemValue;
      acc.totalDiscValue += discountValue;
      acc.totalTaxValue += taxValue;
      acc.totalPfValue += pfValue;
      acc.grandTotalValue += totalValue ;

      return acc;
    },
    {
      totalItemValue: 0,
      totalDiscValue: 0,
      totalTaxValue: 0,
      totalPfValue: 0,
      grandTotalValue: 0,
    }
  );

  const freightAmount = isNaN(parseFloat(formData.frightCharges)) ? 0.00 : parseFloat(formData.frightCharges);
  const finalTotal = totals.grandTotalValue + freightAmount;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  // ✅ 1. Check items
  if (selectedItems.length === 0) {
    Swal.fire("Error", "Please add at least one item", "error");
    return;
  }

  // ✅ 2. Validate required fields
  if (!formData.yourRefNo || isNaN(formData.yourRefNo) || Number(formData.yourRefNo) <= 0) {
    Swal.fire("Validation Error", "Your Ref No must be a valid number greater than 0.", "warning");
    return;
  }

  if (!formData.ourRefNo || isNaN(formData.ourRefNo) || Number(formData.ourRefNo) <= 0) {
    Swal.fire("Validation Error", "Our Ref No must be a valid number greater than 0.", "warning");
    return;
  }

  if (!formData.yourRefDate || isNaN(Date.parse(formData.yourRefDate))) {
    Swal.fire("Validation Error", "Your Ref Date must be a valid date.", "warning");
    return;
  }

  if (!formData.ourRefDate || isNaN(Date.parse(formData.ourRefDate))) {
    Swal.fire("Validation Error", "Our Ref Date must be a valid date.", "warning");
    return;
  }

  if (!formData.paymentTerms || formData.paymentTerms.trim() === "") {
    Swal.fire("Validation Error", "Payment Terms cannot be empty.", "warning");
    return;
  }

  if (!formData.delMethod || formData.delMethod.trim() === "") {
    Swal.fire("Validation Error", "Delivery Method cannot be empty.", "warning");
    return;
  }

if (formData.frightCharges === "" || formData.frightCharges === null) {
  // allow empty if optional
} else {
  const freight = Number(formData.frightCharges);
  if (isNaN(freight)) {
    Swal.fire("Validation Error", "Freight Amount must be a valid positive number.", "warning");
    return;
  }
}

  // ✅ Build payload after validations
  const payload = {
    branch: branch,
    poNumber: formData.PoNumber,
    user: user,
    prNo: priNumber,
    scode: subDetails.supplierMaster_code,
    sName: subDetails.supplierMaster_name,
    yourRefNo: formData.yourRefNo,
    yourRefDate: formData.yourRefDate,
    ourRefNo: formData.ourRefNo,
    ourRefDate: formData.ourRefDate,
    paymentTerms: formData.paymentTerms,
    transport: formData.transport,
    frightAmt: formData.frightCharges,
    delMethod: formData.delMethod,
    delPlace: formData.delPlace,
    grandTot: finalTotal.toFixed(2),
    remarks: formData.remarks,
    priceBasis: formData.priceBasis,
    subValue: totals.totalItemValue.toFixed(2),
    pfValue: totals.totalPfValue.toFixed(2),
    discValue: totals.totalDiscValue.toFixed(2),
    cst: totals.totalTaxValue.toFixed(2),

    items: selectedItems.map((item) => {
      const itemValue = item.prDetail_quantity * item.prDetail_price;
      const discountValue = itemValue * (item.supplierWIdetail_discountPercentage / 100);
      const pfValue = itemValue * (item.supplierWIdetail_PfPercentage / 100);
      const taxValue = itemValue * (item.SupplierWIDetail_CSTtax / 100);
      const totalValue = itemValue + taxValue + pfValue - discountValue;

      return {
        itemCode: item.prDetail_itemcode,
        prDetailNo: item.prDetail_number,
        itemName: item.itemmaster_name,
        itemUom: item.itemmaster_uom,
        orderedQuantity: item.prDetail_quantity,
        price: item.prDetail_price,
        cst: item.SupplierWIDetail_CSTtax,
        pf: item.supplierWIdetail_PfPercentage,
        disc: item.supplierWIdetail_discountPercentage,
        value: totalValue.toFixed(2),
      };
    }),
  };

  console.log(payload);

  try {
    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const response = await axios.post("https://rfs2.infraconsoft.net.in/api/bopurchase_insert", payload);
    Swal.fire("Success", "Branch Office Purchase Order added successfully", "success");
    setSelectedItems([]);
    navigate("/inventory/miscPoView");
  } catch (error) {
    console.error("Error submitting form:", error);
    Swal.fire("Error", "Submission failed. Please try again.", "error");
  }
};


if (!canEntry) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }
  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
             <div className="back-div">
                                                      <h2 className="add-txt">Add Branch Office Purchase Order</h2>
                                                      <Link to='/inventory/miscPoView'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                                                      </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
          <div className="form-row">
              <div className="form-group">
                <label>P.O Number :</label>
                <input type="text" name="PoNumber" value={formData.PoNumber} readOnly />
              </div>
              <div className="form-group">
                <label>P.O Date :</label>
                <input type="date" name="endhrs" value={new Date().toISOString().split("T")[0]} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Supplier Code :</label>
                <input type="text" name="scode" value={subDetails.supplierMaster_code} />
              </div>
              <div className="form-group">
                <label>Supplier Name :</label>
                <input type="text" name="sname" value={subDetails.supplierMaster_name}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Your Ref No :</label>
                <input type="text" name="yourRefNo" value={formData.yourRefNo}  onChange={handleChange}/>
              </div>
              <div className="form-group">
                <label>Your Ref Date :</label>
                <input type="date" name="yourRefDate" value={formData.yourRefDate}  onChange={handleChange}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Our Ref No :</label>
                <input type="text" name="ourRefNo" value={formData.ourRefNo}  onChange={handleChange}/>
              </div>
              <div className="form-group">
                <label>Our Ref Date :</label>
                <input type="date" name="ourRefDate" value={formData.ourRefDate}  onChange={handleChange}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Address 1 :</label>
                <input type="text" name="address1"value={subDetails.supplierMaster_addressline1} />
              </div>
              <div className="form-group">
                <label>Address 2 :</label>
                <input type="text" name="address2" value={subDetails.supplierMaster_addressline2}/>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>City :</label>
                <input type="text" name="city"value={subDetails.supplierMaster_city} />
              </div>
              <div className="form-group">
                <label>Pin Code :</label>
                <input type="text" name="pincode" value={subDetails.supplierMaster_pincode}/>
              </div>
            </div>


            <div className="flex_buttons">
              <button type="button" className="button button-add" onClick={() => setShowModal(true)}>
                Select Supplier for Item
              </button>
            </div>

            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    <th>Qty</th>
                    <th>Price</th>
                    <th>GST%</th>
                    <th>P&F%</th>
                    <th>Disc%</th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedItems.length > 0 ? (
                    selectedItems.map((item, index) => {
                      const itemValue = item.prDetail_quantity * item.prDetail_price;
                      const discountValue = itemValue * (item.supplierWIdetail_discountPercentage / 100);
                      const pfValue = itemValue * (item.supplierWIdetail_PfPercentage / 100);
                      const taxValue = itemValue * (item.SupplierWIDetail_CSTtax / 100);
                      const totalValue = itemValue + taxValue + pfValue - discountValue;

                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.prDetail_itemcode}</td>
                          <td>{item.itemmaster_name}</td>
                          <td>{item.itemmaster_uom}</td>
                          <td>{item.prDetail_quantity}</td>
                          <td>{item.prDetail_price}</td>
                          <td>{item.SupplierWIDetail_CSTtax}</td>
                          <td>{item.supplierWIdetail_PfPercentage}</td>
                          <td>{item.supplierWIdetail_discountPercentage}</td>
                          <td>{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(totalValue)}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="10">No items added</td>
                    </tr>
                  )}
                </tbody>
              </table>

              {/* Billing Summary */}
              <div className="po-bill-container">
                <h2 className="po-bill-title">Billing Summary</h2>
                <div className="po-bill-summary">
                  <div className="po-bill-item">
                    <span className="po-bill-label">Sub Total:</span>
                    <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(totals.totalItemValue)}</span>
                  </div>
                  <div className="po-bill-item">
                    <span className="po-bill-label">GST (18%):</span>
                    <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(totals.totalTaxValue)}</span>
                  </div>
                  <div className="po-bill-item">
                    <span className="po-bill-label">Disc (%):</span>
                    <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(totals.totalDiscValue)}</span>
                  </div>
                  <div className="po-bill-item">
                    <span className="po-bill-label">PF:</span>
                    <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(totals.totalPfValue)}</span>
                  </div>
                  <div className="po-bill-item">
                    <span className="po-bill-label">Fright Charges:</span>
                    <span className="po-bill-value"><input type="number" placeholder="₹ Enter Your Frieght" name="frightCharges" value={formData.frightCharges}  onChange={handleChange}/></span>
                  </div>
                 
                  <div className="po-bill-item">
                    <span className="po-bill-label">Payment Terms:</span>
                    <span className="po-bill-value"><input type="text" name="paymentTerms" value={formData.paymentTerms}  onChange={handleChange}/></span>
                  </div>
                  <div className="po-bill-item">
                    <span className="po-bill-label">Delivery Method:</span>
                    <span className="po-bill-value"><input type="text" name="delMethod" value={formData.delMethod}  onChange={handleChange}/></span>
                  </div>
                  <div className="po-bill-item">
                    <span className="po-bill-label">Remarks:</span>
                    <span className="po-bill-value"><input type="text" name="remarks" value={formData.remarks}  onChange={handleChange}/></span>
                  </div>
                  <div className="po-bill-item po-bill-total">
                    <span className="po-bill-label">Total:</span>
                    
                    <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(finalTotal)}</span>
                  </div>

                </div>
              </div>


            </div>
            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Checkout
              </button>
            </div>
          </form>
        </div>
      </div>

      <MiscPOModal showModal={showModal} closeModal={() => setShowModal(false)} branch={branch} onSelectItem={handleSelectItem} />
    </div>
  );
};

export default AddBOPurchaseOrder;
